<div class="flex-item notMobile" *ngIf="!facetsVisible">
    <p-button icon="fas fa-chevron-right" pTooltip="Show Filters" tooltipPosition="top" (click)="toggleFacets();"
        styleClass="p-button-text p-button-raised text-primary"></p-button>
</div>
<div class="flex-item forMobile" *ngIf="!facetsVisible">
    <p-button icon="fas fa-chevron-up" pTooltip="Show Filters" tooltipPosition="top" (click)="toggleFacets();"
        styleClass="p-button-text p-button-raised text-primary"></p-button>
</div>
<div *ngIf="facetsVisible">
    <div class="d-flex justify-content-between mb-3">
        <div class="flex-item section-header">Search Filters</div>
        <div class="flex-item">
            <!-- <a class="text-primary me-3" (click)="clearFacets();" pTooltip="Clear Filters" tooltipPosition="top"><i class="fas fa-filter-circle-xmark"></i></a> -->
            <a class="text-primary me-3" (click)="clearFacets();" pTooltip="Clear Filters" tooltipPosition="left"><i
                    class="fas fa-filter"></i></a>
            <a class="text-primary notMobile" (click)="toggleFacets();" pTooltip="Hide Filters" tooltipPosition="top"><i
                    class="fas fa-chevron-left"></i></a>
            <a class="text-primary forMobile" (click)="toggleFacets();" pTooltip="Hide Filters"
                tooltipPosition="left"><i class="fas fa-chevron-down"></i></a>
        </div>
    </div>

    <p-accordion>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Organization exchanging documents with Agency"><i
                        *ngIf="selectedAddresseeAffiliation.length>0" class="pi pi-check"></i> Addressee
                    Affiliation</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.AddresseeAffiliation?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.AddresseeAffiliation?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.AddresseeAffiliation">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="AddresseeAffiliation" (onChange)="updateAddresseeAffiliation()"
                                    value="f.value" [value]="f.value" [(ngModel)]="selectedAddresseeAffiliation"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="AddresseeAffiliation">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Person to whom document is addressed"><i
                        *ngIf="selectedAddresseeName.length>0" class="pi pi-check"></i> Addressee Name</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.AddresseeName?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.AddresseeName?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.AddresseeName">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="AddresseeName" (onChange)="updateAddresseeName()" [value]="f.value"
                                    [(ngModel)]="selectedAddresseeName" [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="AddresseeName">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Organization exchanging documents with Agency"><i
                        *ngIf="selectedAuthorAffiliation.length>0" class="pi pi-check"></i> Author Affiliation</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.AuthorAffiliation?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.AuthorAffiliation?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.AuthorAffiliation">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="AuthorAffiliation" (onChange)="updateAuthorAffiliation()"
                                    value="f.value" [value]="f.value" [(ngModel)]="selectedAuthorAffiliation"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="AuthorAffiliation">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Person who approved/is listed on the title page"><i
                        *ngIf="selectedAuthors.length>0" class="pi pi-check"></i> Author Name</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.AuthorName?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.AuthorName?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.AuthorName">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="AuthorName" (onChange)="updateAuthors()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedAuthors" [inputId]="f.value"
                                    ariaLabel="AuthorName_{{f.value}}"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label id="AuthorName_{{f.value}}" class="form-check-label">{{f.value}}
                                    ({{f.count | number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>

        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Date the document was added to ADAMS. {{ dateMsg }}" [escape]="false"><i
                        *ngIf="selectedDateAdded.length>0" class="pi pi-check"></i> Date Added <i class="pi pi-info-circle" style="font-size: .8rem"></i>
                </span>
                <ng-template #dateAddedTooltip>
                    <span>Date the document was added to ADAMS. <br/> {{ dateMsg }}</span>
                </ng-template>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.DateAdded?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.DateAdded?.length != 0">
                    <div class="d-flex flex-column">
                        <app-results-facet-date [facetDetails]="facets?.DateAdded" facetName="DateAdded"
                            [selectedItems]="selectedDateAddedNodes" (onSelected)="updateDateAdded($event)"
                            (onRemoved)="removedDateAdded($event)"></app-results-facet-date>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="NRC-assigned number identifying a facility, licensee, or activity"><i
                        *ngIf="selectedDocketNumber.length>0" class="pi pi-check"></i> Docket
                    Number</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.DocketNumber?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.DocketNumber?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.DocketNumber">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="DocketNumber" (onChange)="updateDocketNumber()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedDocketNumber"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="DocketNumber_{{f.value}}">{{f.value}}
                                    ({{f.count | number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Date Document was Created. {{ dateMsg }}" [escape]="false"><i
                        *ngIf="selectedDocumentDate.length>0" class="pi pi-check"></i> Document Date <i class="pi pi-info-circle" style="font-size: .8rem"></i></span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.DocumentDate?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.DocumentDate?.length != 0">
                    <div class="d-flex flex-column">
                        <app-results-facet-date [facetDetails]="facets?.DocumentDate" facetName="DocumentDate"
                            [selectedItems]="selectedDocumentDateNodes" (onSelected)="updateDocumentDate($event)"
                            (onRemoved)="removedDocumentDate($event)"></app-results-facet-date>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Unique number used to identify/retrieve a document"><i
                        *ngIf="selectedDocumentReportNumber.length>0" class="pi pi-check"></i> Document Report
                    Number</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.DocumentReportNumber?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.DocumentReportNumber?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.DocumentReportNumber">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="DocumentReportNumber" (onChange)="updateDocumentReportNumber()"
                                    value="f.value" [value]="f.value" [(ngModel)]="selectedDocumentReportNumber"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="DocumentReportNumber">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Identifies the type of document"><i
                        *ngIf="selectedDocumentType.length>0" class="pi pi-check"></i> Document
                    Type</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.DocumentType?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.DocumentType?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.DocumentType">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="DocumentType" (onChange)="updateDocumentType()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedDocumentType"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="DocumentType">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="NRC/State-assigned number identifying a license or permit holder"><i
                        *ngIf="selectedLicenseNumber.length>0" class="pi pi-check"></i> License
                    Number</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.LicenseNumber?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.LicenseNumber?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.LicenseNumber">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="LicenseNumber" (onChange)="updateLicenseNumber()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedLicenseNumber"
                                    [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="LicenseNumber">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="NRC/State-assigned number identifying a license or permit holder"><i
                        *ngIf="selectedIsLegacy.length>0" class="pi pi-check"></i> Is Legacy</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.IsLegacy?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.IsLegacy?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.IsLegacy">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="IsLegacy" (onChange)="updateIsLegacy()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedIsLegacy" [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="IsLegacy">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="form-label" pTooltip="Is Item a Package"><i *ngIf="selectedIsPackage.length>0"
                        class="pi pi-check"></i> Is Package</span>
            </ng-template>
            <ng-template pTemplate="content">
                <div *ngIf="!facets?.IsPackage?.length">
                    <app-results-empty-facet></app-results-empty-facet>
                </div>
                <div *ngIf="facets?.IsPackage?.length != 0">
                    <div class="p-field-checkbox" *ngFor="let f of facets?.IsPackage">
                        <div class="row">
                            <div class="col-1">
                                <p-checkbox name="IsPackage" (onChange)="updateIsPackage()" value="f.value"
                                    [value]="f.value" [(ngModel)]="selectedIsPackage" [inputId]="f.value"></p-checkbox>
                            </div>
                            <div class="col-11">
                                <label class="form-check-label" for="IsPackage">{{f.value}} ({{f.count |
                                    number:'1.0':'en-US'}})</label>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-accordionTab>
    </p-accordion>
</div>